var render = function render(){var _vm=this,_c=_vm._self._c;return _c('assign',{attrs:{"ID":_vm.ID,"value":_vm.configurationID},scopedSlots:_vm._u([{key:"activator",fn:function({on}){return [_c('div',_vm._g({staticClass:"text-center"},on),[_vm._v(_vm._s(_vm.currentConfiguration))])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }